/** Small pure helpers shared by the module's components. */

/** Tone that follows performance: helps scanning, always paired with the number. */
export function performanceTone(
  percent: number | null,
): 'success' | 'primary' | 'warning' | 'error' {
  if (percent === null) return 'primary';
  if (percent >= 70) return 'success';
  if (percent >= 50) return 'primary';
  if (percent >= 30) return 'warning';
  return 'error';
}

/** Strips markdown for one-line previews of a statement. */
export function plainText(markdown: string, max = 160): string {
  const text = markdown
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '[imagem]')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^\s*(?:[-*+]|\d+\.)\s+/gm, '') // list markers
    .replace(/^\s*\|?[\s:|-]+\|[\s:|-]*$/gm, ' ') // table separator rows
    .replace(/[`*>#|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > max ? `${text.slice(0, max - 1)}…` : text;
}
